module.exports = __webpack_public_path__ + "static/media/lucina-lose.dab0d265.png";